import React from 'react'
import GreyBoxForReports from './GreyBoxForReports'
import { ApiGetCall } from '../../JS/Connector';
import { formatDateToMMDDYYYY, LogInUserID, MMDDYYYY } from '../../JS/Common';
import AlertsComp from '../../Components/AlertsComp';

export default function VendorTickets({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    async function GetAllAccountsData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);

        setTimeout(() => {
            setalerts(<AlertsComp show={true} variant="success" msg={`You will receive an email notification once matching data is found and processed.`} />);
            setLoading(false);
        }, 2000);

        setTimeout(() => {
            setalerts(<AlertsComp show={false} />);
        }, 5000);

        setTimeout(() => {
            ApiGetCall(`/reports/incoming-outgoing-batch-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&userId=${LogInUserID}&flag=${downloadall}`);
        }, 0);
    }
    return (
        <GreyBoxForReports icon="faExchangeAlt" name={"Incoming / Outgoing Vendor Tickets Report Download"} onclickfunc={GetAllAccountsData} />
    )
}
